<template>
<div>
  <vue-header/>
  <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
        <b-card no-body dark>
          <b-tabs pills card >
            <b-tab title="Current Timesheets" @click="loadDTCUR()" active>
              <b-card-text>
                <button v-if="current_timesheet_flag == 0" type="button" class="btn btn-primary btn-lg btn-block" style="margin-bottom:5px;font-size:15px;" @click="addTimeSheet">Create New Timesheet</button>
                <table id="curtable" class="display responsive nowrap">
                  <thead>
                        <tr>
                            <th>Pay Period</th>
                            <th>Created On</th>
                            <th>Updated On</th>
                            <th>Total Time</th>
                            <th>Created By</th>
                            <!-- <th>Action</th> -->
                            <th></th>
                        </tr>
                    </thead>
                </table>

              </b-card-text>
            </b-tab>
            <b-tab title="Past Timesheets" @click="loadDTPAST()" >
              <b-card-text>
                  <table id="past_table" class="display responsive nowrap">
                    <thead>
                        <tr>
                            <th>Pay Period</th>
                            <th>Created On</th>
                            <th>Updated On</th>
                            <th>Total Time</th>
                            <th>Created By</th>
                            <!-- <th>Action</th> -->
                            <th></th>
                        </tr>
                    </thead>
                </table>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
  </div>
</div>
</template>

<script>
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
name: 'Timesheet',
components : {Loading},
data() {
    return {
      constants: CommonConstants,
      header: {},
      moment: moment,
      isLoading: true,
      timeSheetData :[],
      last_pay_period :'',
      current_pay_period:'',
      current_timesheet_flag: 1
    }
  },
  mounted : function(){
    let self = this;
    self.header = {
        'Content-type': "application/json",
        'token': localStorage.getItem('token')
    }
    setTimeout(function() {
      self.loadDTPAST();
    }, 1000);
    setTimeout(function() {
      self.loadDTCUR();
    }, 1000);
  },
  methods :{
    loadDTCUR (){
      var self = this;
      self.isLoading = true;
      $("#curtable").DataTable({
        // processing: true,
        //serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1
            }
        },
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        ],
        "initComplete": function( settings, json ) {
            self.isLoading = false;
        },
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   false,
        destroy: true,
        orderClasses: false,
        language: {
          emptyTable: "There are no Current Timesheets available.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>'
          },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + "timesheets",
          type: "GET",
          dataType: "json",
          dataSrc: function (result) {
            self.allTagsModel = result.data.current_timesheets;
            self.last_pay_period = result.data.last_pay_period;
            self.current_pay_period = result.data.current_pay_period;
            self.current_timesheet_flag = result.data.current_timesheet_flag;
            return self.allTagsModel;
          }
        },
        columns: [
          {
            render: function(data, type, full, meta) {
              return (
                '<router-link to="/add"><a href="/timesheets/currentView/'+full.id+'">' + full.period_start +' - '+ full.period_end +'</a></router-link>'
              );
            }

          },
          {
            title: "Created On",
            render: function(data, type, full, meta) {
              return moment(full.created_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');

            }
          },
          {
            title: "Last Update",
            render: function(data, type, full, meta) {
              return moment(full.updated_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');
            }
          },
          { data: "totalTime" },
          { data: "created_by_name" },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });
      $("#past_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    loadDTPAST (){
      var self = this;
      self.isLoading = true;
      $("#past_table").DataTable({
        // processing: true,
        //serverSide: true,
        responsive: {
            details: {
                type: 'column',
                target: -1
            }
        },
        "ordering": false,
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1,
        },
        ],
        "dom": '<"top">rit<"bottom"p><"clear">',
        "paging":   false,
        destroy: true,
        orderClasses: false,
        "initComplete": function( settings, json ) {
            self.isLoading = false;
          },
        language: {
          emptyTable: "There are no Past Timesheets available.",
          search: "INPUT",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>'
          },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> MENU"
        },
        ajax: {
          headers: self.header,
          url: self.constants.api_url + "timesheets",
          type: "GET",
          dataType: "json",
          dataSrc: function (result) {
            self.allTagsModel = result.data.approved_timesheets;
            return self.allTagsModel;
          }
        },
        columns: [
          {
            render: function(data, type, full, meta) {
              return (
                '<router-link to="/add"><a href="/timesheets/view/'+full.id+'">' + full.period_start +' - '+ full.period_end +'</a></router-link>'
              );
            }

          },
          {
            title: "Created On",
            render: function(data, type, full, meta) {
              return moment(full.created_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');

            }
          },
          {
            title: "Last Update",
            render: function(data, type, full, meta) {
              return moment(full.updated_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY, hh:mm a');
            }
          },
          { data: "totalTime" },
          { data: "created_by_name" },
          {
            render: function(data, type, full, meta) {
              return (
                ''
              );
            }
          }
        ]
      });

      $("#past_table").on("page.dt", function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        $("th:first-child").focus();
      });
    },
    addTimeSheet (){
      this.$router.push('/timesheets/add')
    }
  }
}
</script>

<style>
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: #fff;
    background-color: #17a2b8 !important;
}
</style>
